export const VIDEO_URL =
  'https://iframe.mediadelivery.net/embed/517647/6a98cc98-5148-4a32-84e9-f02809e9199c';
